module.exports = __webpack_public_path__ + "static/media/BryanMills.c4231d4e.jpg";